export default {
  methods: {
    redirect (response) {
      window.location.replace(response);
    }
  }
}
